export function replacePathParams(url: string, params?: Record<string, string | number | boolean>) {
    if (!params) {
        return url;
    }
    // also clean up the splash / in the end of the url after replacing the params
    return url
        .replace(/\/:([^/?]+)\??/g, (_, key) => {
            if (params[key] !== undefined) {
                return `/${encodeURIComponent(params[key])}`;
            }
            return "";
        })
        .replace(/\/$/, "");
}
